<template>
  <div>
    <h3 class="text-bold">Update {{ supplier.name }}</h3>

    <div class="alert alert-danger mt-20" v-if="Object.keys(errors).length">
      <h4 class="semi-bold text-danger">
        <span class="fa fa-exclamation-triangle"></span> Sorry, there were some
        errors!
      </h4>
      <p class="text-danger">
        Please check the form, correct the issues and try again.
      </p>
    </div>

    <div class="grid shadow bg-white mt-20">
      <div class="grid-title">
        <h4 class="semi-bold">Base Supplier Information</h4>
      </div>
      <div class="grid-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Name</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="supplier.name"
                  placeholder="Supplier's Name"
                />
                <small v-if="errors.name" class="form-text text-danger">
                  {{ errors.name.join(" ") }}
                </small>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Code</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="supplier.code"
                  placeholder="Supplier Code"
                />
                <small v-if="errors.code" class="form-text text-danger">
                  {{ errors.code.join(" ") }}
                </small>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label"
                >Delivery Efficiency (Week)</label
              >
              <div class="col-sm-10">
                <input
                  type="number"
                  class="form-control"
                  v-model="supplier.delivery_efficiency"
                  placeholder="Week"
                />
                <small
                  v-if="errors.delivery_efficiency"
                  class="form-text text-danger"
                >
                  {{ errors.delivery_efficiency.join(" ") }}
                </small>
              </div>
            </div>
            <hr />
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Bank Name</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="supplier.bank_name"
                  placeholder="Bank Name (e.g. Kasikorn Bank)"
                />
                <small v-if="errors.bank_name" class="form-text text-danger">
                  {{ errors.bank_name.join(" ") }}
                </small>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Bank Account Number</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="supplier.bank_account_number"
                  placeholder="Account Number"
                />
                <small
                  v-if="errors.bank_account_number"
                  class="form-text text-danger"
                >
                  {{ errors.bank_account_number.join(" ") }}
                </small>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Bank Routing Code</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="supplier.bank_account_routing_code"
                  placeholder="Routing Code / BIC / SwiftBIC"
                />
                <small
                  v-if="errors.bank_account_routing_code"
                  class="form-text text-danger"
                >
                  {{ errors.bank_account_routing_code.join(" ") }}
                </small>
              </div>
            </div>
            <hr />
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Address</label>
              <div class="col-sm-1">
                <input
                  type="text"
                  class="form-control"
                  v-model="supplier.address"
                  placeholder="Number"
                />
              </div>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  v-model="supplier.street"
                  placeholder="Street"
                />
              </div>
              <div class="col-sm-2"></div>
              <div class="col-sm-10">
                <small v-if="errors.address" class="form-text text-danger">
                  {{ errors.address.join(" ") }}
                </small>
                <small v-if="errors.street" class="form-text text-danger">
                  {{ errors.street.join(" ") }}
                </small>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">City</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="supplier.city"
                  placeholder="City"
                />
                <small v-if="errors.city" class="form-text text-danger">
                  {{ errors.city.join(" ") }}
                </small>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Country</label>
              <div class="col-sm-10">
                <country-select
                  v-model="supplier.country"
                  className="form-control"
                  :country="supplier.country"
                  topCountry="TH"
                />
                <small v-if="errors.country" class="form-text text-danger">
                  {{ errors.country.join(" ") }}
                </small>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Zip/Postal Code</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="supplier.zip"
                  placeholder="Zip/Postal Code"
                />
                <small v-if="errors.zip" class="form-text text-danger">
                  {{ errors.zip.join(" ") }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid shadow bg-white mt-20">
      <div class="grid-title">
        <h4 class="semi-bold">Contact Information</h4>
      </div>
      <div class="grid-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Phone</label>
              <div class="col-sm-10">
                <input
                  type="phone"
                  class="form-control"
                  v-model="supplier.phone"
                  placeholder="Phone"
                />
                <small v-if="errors.phone" class="form-text text-danger">
                  {{ errors.phone.join(" ") }}
                </small>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Email</label>
              <div class="col-sm-10">
                <input
                  type="email"
                  class="form-control"
                  v-model="supplier.email"
                  placeholder="Email"
                />
                <small v-if="errors.email" class="form-text text-danger">
                  {{ errors.email.join(" ") }}
                </small>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Website</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="supplier.website"
                  placeholder="Website"
                />
                <small v-if="errors.website" class="form-text text-danger">
                  {{ errors.website.join(" ") }}
                </small>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Title</label>
              <div class="col-sm-2">
                <select
                  class="form-control"
                  v-model="supplier.contact_person_title"
                >
                  <option value="Mr.">Mr.</option>
                  <option value="Mrs.">Mrs.</option>
                  <option value="Miss.">Miss.</option>
                  <option value="Ms.">Ms.</option>
                </select>
                <small
                  v-if="errors.contact_person_title"
                  class="form-text text-danger"
                >
                  {{ errors.contact_person_title.join(" ") }}
                </small>
              </div>
              <label class="col-sm-2 col-form-label">Contact Person Name</label>
              <div class="col-sm-6">
                <input
                  type="text"
                  class="form-control"
                  v-model="supplier.contact_person_name"
                  placeholder="Name"
                />
                <small
                  v-if="errors.contact_person_name"
                  class="form-text text-danger"
                >
                  {{ errors.contact_person_name.join(" ") }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button
      class="btn-primary btn-large btn btn-block"
      @click="updateSupplier()"
      v-if="!isReadOnlyUser"
    >
      Update Supplier
    </button>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import vSelect from "vue-select";
import vueCountryRegionSelect from "vue-country-region-select";

export default {
  components: {
    vSelect,
    vueCountryRegionSelect,
  },
  data() {
    return {
      country: "",
      result: null,
      errors: {},
      isReadOnlyUser: false,
      supplier: {
        name: "",
        code: "",
        bank_name: "",
        bank_account_number: "",
        bank_account_routing_code: "",
        address: "",
        street: "",
        city: "",
        country: "",
        zip: "",
        phone: "",
        email: "",
        website: "",
        contact_person_title: "Mr.",
        contact_person_name: "",
      },
    };
  },
  mounted() {
    let supplierId = this.$route.params.supplier_id;
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.loadSupplier(supplierId);
  },
  methods: {
    async loadSupplier(supplierId) {
      try {
        let results = await axios({
          method: "get",
          url: "/v2/fabrics/suppliers/" + supplierId + "/edit",
        });
        this.supplier = results.data.data;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },
    async updateSupplier() {
      try {
        let supplierId = this.$route.params.supplier_id;
        this.errors = {};
        let results = await axios({
          method: "put",
          url: "/v2/fabrics/suppliers/" + supplierId,
          data: this.supplier,
        });
        this.$router.push("/fabric/suppliers");
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.errors = error.response.data.errors;
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
        window.scrollTo(0, 0);
      }
    },
  },
};
</script>

<style scoped>
@import "~sweetalert2/dist/sweetalert2.min.css";
@import "~vue-select/dist/vue-select.css";

.col-form-label {
  margin-top: 10px;
}
</style>
